import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { MobileStepper, Button } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { useCustomTranslation } from '../../translation/customTranslation';
import { StepperProps } from './stepperProps.interface';

export const Stepper = ({
  totalSteps,
  stepperDomain,
  customNext,
  customNextText,
  customNextAction,
}: StepperProps) => {
  const theme = useTheme();
  const currentStep = stepperDomain.useActiveStepSelector();
  const nextEnabled = stepperDomain.useNextEnabledSelector();
  const backEnabled = stepperDomain.useBackEnabledSelector();
  const progressWidth = currentStep / totalSteps;
  const { t } = useCustomTranslation();

  const nextButtonText = customNext
    ? customNextText
    : 'common.generic.GENERIC_NAVIGATION_NEXT';
  const onNext = customNext
    ? customNextAction
    : () => stepperDomain.dispatchIncrementActiveStep();

  return (
    <>
      <MobileStepper
        variant="progress"
        steps={totalSteps}
        position="static"
        activeStep={currentStep}
        sx={{
          flexGrow: 1,
          my: 2,
          '.MuiMobileStepper-progress': {
            xs: { width: '30%' },
            sm: { width: '30%' },
            md: { width: '45%' },
          },
        }}
        nextButton={
          <Button
            size="small"
            onClick={onNext}
            disabled={!nextEnabled}
            variant="contained"
            color="secondary"
          >
            {t(nextButtonText)}
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => stepperDomain.dispatchDecrementActiveStep()}
            disabled={currentStep === 0 || !backEnabled}
          >
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            {t('common.generic.GENERIC_NAVIGATION_PREV')}
          </Button>
        }
      />
    </>
  );
};
